export const isStr = (val) => typeof val === "string";
export const isNumber = (value) => {
    return typeof value === "number" && !Number.isNaN(value);
};
export const range = (size, startAt = 1) => {
    return [...Array(size).keys()].map((i) => i + startAt);
};
export const clamp = (value, min, max) => {
    value = min != null && value < min ? min : value;
    return max != null && value > max ? max : value;
};
//# sourceMappingURL=utils.js.map
